(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creg-benefits-orbit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('creg-benefits-orbit')) {
  customElements.define('creg-benefits-orbit', class extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.creg-orbit__stage');
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.layout());
      };
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      this.querySelectorAll('.creg-orbit__copy').forEach(el => this.observer.observe(el));
      this.mediaQuery = window.matchMedia('(max-width:899px)');
      this.mediaQuery.addEventListener('change', this.update);
      this.update();
      document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
    }
    layout() {
      if (!this.stage) return;
      if (!this.mediaQuery.matches || this.classList.contains('creg-orbit--list')) {
        ['--safe-ring-height','--safe-top-space','--safe-bottom-space'].forEach(p => this.stage.style.removeProperty(p));
        return;
      }
      const style = getComputedStyle(this);
      const icon = parseFloat(style.getPropertyValue('--icon-size-mobile')) || 36;
      const baseHeight = parseFloat(style.getPropertyValue('--ring-height-mobile')) || 310;
      const stageWidth = this.stage.getBoundingClientRect().width;
      const requestedText = parseFloat(style.getPropertyValue('--text-width-mobile')) || 112;
      const ringRatio = (parseFloat(style.getPropertyValue('--ring-width-mobile')) || 62) / 100;
      const edgeSpace = stageWidth * (.5 - ringRatio * .414);
      const safeText = Math.floor(Math.min(requestedText, edgeSpace * 2 - 8, stageWidth * .38));
      this.stage.style.setProperty('--safe-text-width', `${Math.max(60, safeText)}px`);
      const heights = Array.from(this.querySelectorAll('.creg-orbit__copy'), el => el.getBoundingClientRect().height);
      const sideHeight = Math.max(0, heights[1] || 0, heights[2] || 0, heights[4] || 0, heights[5] || 0);
      const values = {
        '--safe-ring-height': Math.ceil(Math.max(baseHeight, (sideHeight + 10) / .22)),
        '--safe-top-space': Math.ceil((heights[0] || 0) + icon / 2 + 16),
        '--safe-bottom-space': Math.ceil((heights[3] || 0) + icon / 2 + 26)
      };
      Object.entries(values).forEach(([key, value]) => {
        if (this.stage.style.getPropertyValue(key) !== `${value}px`) this.stage.style.setProperty(key, `${value}px`);
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.mediaQuery?.removeEventListener('change', this.update);
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
